import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	recent: {
		defaultMessage: 'Recent',
		id: 'atlassian-navigation.projects.menu.recent-content.recent',
		description: 'Recent project item',
	},
});
